enum TYPE_PARAMETRE {
  INTEGER = "Nombre entier",
  STRING = "Texte",
  GEOMETRY = "Géométrie",
  BINARY = "Fichier",
  DOUBLE = "Nombre décimal",
  BOOLEAN = "Booléen",
  MULTI_STRING = "Liste de valeurs définies",
  MULTI_INT = "Liste d'entiers positifs",
  SELECT = "Choix parmi une liste",
}
export default TYPE_PARAMETRE;
